import script from "./CaskVideoPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskVideoPlay.vue?vue&type=script&setup=true&lang=js"

import "./CaskVideoPlay.vue?vue&type=style&index=0&id=def16f94&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-def16f94"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QScrollArea,QList,QItem,QItemSection});qInstall(script, 'directives', {Ripple});
